import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';

export class BaseConfirmationDialogOptions {
    TitleText?: string;
    MessageText?: string;
    SubMessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    DelayDelete?: number;
    height?: string;
    width?: string;
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    message: string;
    submessage: string;
    iconcolor: string;
    iconname: string;
    oktext: string;
    canceltext: string;
    showIcon: boolean;
    delayDelete: number = 0;
    disableDelete: boolean;

    countDown: Subscription;
    counter = 5;
    tick = 1000; // seconds

    constructor(
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BaseConfirmationDialogOptions
    ) {
        this.title = data.TitleText || 'Confirmation Requested...';
        this.message = data.MessageText || '';
        this.submessage = data.SubMessageText || '';
        this.iconcolor = data.IconColor || 'primary';
        this.iconname = data.IconName || 'help';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.showIcon = data.ShowIcon != null ? data.ShowIcon : true;
        this.delayDelete = data.DelayDelete ? data.DelayDelete * 1000 : null;
        this.disableDelete = data.DelayDelete ? true : false;
    }

    ngOnInit(): void {
        // If a delay is specified, the Delete button will be disabled until the timer has elapsed.
        // This is to prevent accidental double-click for specific delete actions.
        if (this.delayDelete) {
            this.countDown = timer(0, this.tick).subscribe(() => 
            {
                --this.data.DelayDelete;
                this.data.DelayDelete === 0 ? this.disableDelete = false : null;
            });
            // setTimeout((_) => (this.disableDelete = false), this.delayDelete);
        }
    }

    ngOnDestroy(){
        this.countDown=null;
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(true);
    }
}
